import request from '@/config/axios'

const base = (userMode = false) => `/bosscircle/${userMode ? 'user-news-comment' : 'news-comment'}`
export const getCommentPage = (params: any, userMode = false) =>
  request.get({ url: `${base(userMode)}/page`, params })
export const updateCommentStatus = (id: number, status: number, userMode = false) =>
  request.put({ url: `${base(userMode)}/status`, params: { id, status } })
export const batchUpdateCommentStatus = (ids: number[], status: number, userMode = false) =>
  request.put({
    url: `${base(userMode)}/batch-status`,
    params: { ids: ids.join(','), status }
  })
export const deleteComment = (id: number, userMode = false) =>
  request.delete({ url: `${base(userMode)}/delete`, params: { id } })
export const batchDeleteComment = (ids: number[], userMode = false) =>
  request.delete({ url: `${base(userMode)}/batch-delete`, params: { ids: ids.join(',') } })
